import { computed } from 'vue'

export default (props, { emit }) => {
  const attrs = computed(() => {
    return {
      style: {
        pointerEvents: props.isActive ? null : 'none'
      }
    }
  })

  function open () {
    emit('update:isActive', true)
  }

  function close () {
    emit('update:isActive', false)
  }

  return {
    attrs,
    listeners: {
      mouseenter () {
        open()
      },
      mouseleave () {
        close()
      }
    }
  }
}
